export default "/assets/images/mama-room2.png?63cfb99824b14d8846cf4e1f0382d3af";